import React from 'react'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { cn } from '@/lib/utils'
import { AvatarDescriptor } from '@/components/OGE/Tabbar/sidebarTabTypes'

type NegotiationTabAvatarsProps = {
  avatars?: AvatarDescriptor[]
  maxVisible?: number
  size?: 'sm' | 'md'
}

const NegotiationTabAvatars: React.FC<NegotiationTabAvatarsProps> = ({
  avatars = [],
  maxVisible = 5,
  size = 'sm',
}) => {
  if (avatars.length === 0) return null

  const visible = avatars.slice(0, maxVisible)
  const overflow = avatars.length - maxVisible
  const sizeClass = size === 'sm' ? 'h-5 w-5' : 'h-6 w-6'
  const textClass = size === 'sm' ? 'text-[8px]' : 'text-[9px]'

  return (
    <div className='flex items-center flex-shrink-0'>
      <div className='flex -space-x-1.5'>
        {visible.map((avatar, index) => (
          <Avatar
            key={`${avatar.fallback}-${index}`}
            className={cn(sizeClass, 'ring-1 ring-white')}
          >
            <AvatarImage
              src={avatar.src}
              alt={avatar.fallback}
              className='object-cover'
            />
            <AvatarFallback
              className={cn(
                'bg-sky-200 text-sky-800 font-semibold',
                textClass
              )}
            >
              {avatar.fallback.slice(0, 2).toUpperCase()}
            </AvatarFallback>
          </Avatar>
        ))}
      </div>
      {overflow > 0 && (
        <span
          className={cn(
            'ml-0.5 text-[9px] font-semibold text-slate-500',
            textClass
          )}
        >
          +{overflow}
        </span>
      )}
    </div>
  )
}

export default NegotiationTabAvatars
